import { createTriggerCharExtension } from "../extensions/trigger-char"

export const SnippetTriggerExtension = createTriggerCharExtension({
	name: "snippet-trigger",
	char: ";",
	eventName: "open-snippets",
})
